import { render, staticRenderFns } from "./gSite.vue?vue&type=template&id=16c5e78f&scoped=true&"
import script from "./gSite.vue?vue&type=script&lang=js&"
export * from "./gSite.vue?vue&type=script&lang=js&"
import style0 from "./gSite.vue?vue&type=style&index=0&id=16c5e78f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5e78f",
  null
  
)

export default component.exports